export default "__VITE_ASSET__su3oe2EH__"